import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { CLPUser, UserResponse } from '../../../models/clpuser.model';
import { eFeatures, eUserRole } from '../../../models/enum.model';
import { RoleFeaturePermissions } from '../../../models/roleContainer.model';
import { VoiceTreeOption, VoiceTreeOptionListResponse } from '../../../models/voiceTreeList';
import { GlobalService } from '../../../services/global.service';
import { GridConfigurationService } from '../../../services/shared/gridConfiguration.service';
import { LocalService } from '../../../services/shared/local.service';
import { isNullOrUndefined, UtilityService } from '../../../services/shared/utility.service';
import { VoiceCallService } from '../../../services/voice-call.service';

@Component({
    selector: 'app-voice-tree-option-list',
    templateUrl: './voice-tree-option-list.component.html',
    styleUrl: './voice-tree-option-list.component.css'
})
export class VoiceTreeOptionListComponent {
    private encryptedUser: string = '';
    showSpinner: boolean = false;
    user: CLPUser;
    userResponse: UserResponse;
    @Input() voiceTreeId: number = 0;
    voiceTreeOption: VoiceTreeOption;
    vtOptionForm: FormGroup;
    roleFeaturePermissions: RoleFeaturePermissions;
    voiceTreeOptionListResponse: VoiceTreeOptionListResponse;
    @Input() voiceTreeOptionList: VoiceTreeOption[];
    @ViewChild(MatSort) sort!: MatSort;
    vtOptionListSource: MatTableDataSource<any> = new MatTableDataSource([]);
    vtOptionListDisplayColumns: string[] = [];
    @ViewChild(MatTable) table!: MatTable<any>;
    columns = [
        { field: 'digit', title: 'Digit', width: '50' },
        { field: 'name', title: 'Option', width: '80' },
        { field: 'typeDisplay', title: 'Transfer To', width: '80' },
        { field: 'valueDisplay', title: 'Action', width: '80' }
    ];
    @Output() rowSelected = new EventEmitter<VoiceTreeOption>();

    constructor(private _globalService: GlobalService,
        public _localService: LocalService,
        private _utilityService: UtilityService,
        private _router: Router,
        public _gridCnfgService: GridConfigurationService,
        private _voiceCallService: VoiceCallService,) {
    }

    ngOnInit(): void {
        this.vtOptionListDisplayColumns = this.columns.map(x => x.field);
        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                this.authenticateR().then(() => {
                    if (this.user) {
                        this.setUp();
                    }
                    else
                        this._router.navigate(['/login']);
                })
            }
            else
                this._router.navigate(['/login']);
        })
    }

    setUp() {
        if (this.voiceTreeOptionList && this.voiceTreeOptionList?.length > 0)
            this.setGrid(this.voiceTreeOptionList);
        else 
            this.getVTOptionList();
    }

    async getVTOptionList() {
        await this._voiceCallService.getVTOptionList(this.encryptedUser, this.voiceTreeId)
            .then(async (result: VoiceTreeOptionListResponse) => {
                if (result) {
                    this.voiceTreeOptionListResponse = UtilityService.clone(result);
                    if (this.voiceTreeOptionListResponse.messageBool) {
                        this.voiceTreeOptionList = this.voiceTreeOptionListResponse.voiceTreeOptionList;
                        if (this.voiceTreeOptionList && this.voiceTreeOptionList?.length > 0)
                            this.setGrid(this.voiceTreeOptionList);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async authenticateR() {
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.None)
            .then(async (result: UserResponse) => {
                if (!isNullOrUndefined(result)) {
                    await this._localService.checkIfExpiredOrUnauthorized(result?.user);
                    const response = UtilityService.clone(result);
                    if (!isNullOrUndefined(response)) {
                        if (!isNullOrUndefined(response?.user)) {
                            this.user = response.user;
                            this.roleFeaturePermissions = response.roleFeaturePermissions;
                            this._gridCnfgService.user = this.user;
                            if (this.user?.userRole <= eUserRole.Administrator) {
                                if (this.roleFeaturePermissions?.view == false)
                                    this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                            }
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("voice-tree-option-list.authenticateR", err.message, null, 'Features ' + eFeatures.None);
                this._utilityService.handleErrorResponse(err);
            });
    }

    ngAfterViewInit() {
        if (this.sort) {
            this.vtOptionListSource.sort = this.sort;
        }
        if (this.voiceTreeOptionList) {
            this.setGrid(this.voiceTreeOptionList);
        }
    }

    setGrid(list: any) {
        this.vtOptionListDisplayColumns = this.columns.map(x => x.field);
        this.vtOptionListSource.data = list;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['voiceTreeOptionList']) {
            const list = changes['voiceTreeOptionList'].currentValue || [];
            this.vtOptionListSource.data = [...list];
            setTimeout(() => {
                if (this.sort) {
                    this.vtOptionListSource.sort = this.sort;
                }
            });
        }
    }


    onRowClick(row: VoiceTreeOption) {
        this.rowSelected.emit({ ...row });
    }

}
